<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let { admins = [], hidden_columns: hiddenColumns = [] } = $props()

  const resendInvite = (admin) => {
    router.post('/admins/invite', { admin: { email: admin.email, name: admin.name } }, { preserveScroll: true })
  }

  const archiveAdmin = async (admin) => {
    const ok = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!ok) return
    router.delete(`/admins/${admin.id}`, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Admins" subtitle="Team members with CMS access" count={admins.length}>
    {#snippet actions()}
      <!-- manage_admins is enough to invite (as for Resend Invite); without manage_abilities the
           invite form locks the permission checkboxes and the server drops ability_names. -->
      <Button href="/admins/invite" variant="primary" size="sm" icon="add">Invite Admin</Button>
    {/snippet}
  </PageHeader>

  <EntityList entity="admin" rows={admins} {hiddenColumns} onDelete={archiveAdmin}>
    {#snippet actions(admin)}
      {#if !admin.verified}
        <Button variant="ghost" size="xs" square icon="resend" title="Resend Invite" aria-label="Resend Invite" onclick={() => resendInvite(admin)} />
      {/if}
      <Button variant="ghost" size="xs" square icon="edit" title="Edit" aria-label="Edit" href={admin.edit_url} />
      <Button variant="ghost" size="xs" square icon="delete" title="Archive" aria-label="Archive" class="text-error" onclick={() => archiveAdmin(admin)} />
    {/snippet}
  </EntityList>
</Layout>
